import { useEffect, useRef } from 'react';

import { ILottie } from '@lottielab/lottie-player/react';

import LottieAnimation from './Lottie';
import { Button } from './new-button';
import DownloadAnimation from '@/assets/animations/Download.json';

interface DownloadProps {
  downloadStart: boolean;
  downloadComplete: boolean;
  handleDownload: () => void;
  variant?: 'icon' | 'chip' | 'button';
  textSize?: 'xs' | 'sm' | 'md' | 'lg';
}

const Download = ({
  downloadStart,
  downloadComplete,
  handleDownload,
  variant = 'chip',
  textSize = 'sm',
}: DownloadProps) => {
  const lottieRef = useRef<ILottie | null>(null);

  const switchState = (stateName: string) => {
    lottieRef.current?.interactivity?.trigger(stateName);
  };

  useEffect(() => {
    if (downloadComplete) {
      switchState('complete');
      return;
    }
    if (downloadStart) {
      switchState('start');
    }
  }, [downloadStart, downloadComplete]);

  if (variant === 'icon') {
    return (
      <div onClick={handleDownload} className="h-6 w-6 rounded-full">
        <LottieAnimation lottieRef={lottieRef} animationData={DownloadAnimation} className="h-6 w-6" />
      </div>
    );
  }

  if (variant === 'button') {
    return (
      <Button variant="outline" className={`text-${textSize}`} size="sm" onClick={handleDownload}>
        <LottieAnimation lottieRef={lottieRef} animationData={DownloadAnimation} className="h-5 w-5" />
        Download
      </Button>
    );
  }

  return (
    <div
      onClick={handleDownload}
      className="flex items-center gap-1 rounded-full border px-3 py-2 hover:cursor-pointer hover:bg-gray-200"
    >
      <LottieAnimation lottieRef={lottieRef} animationData={DownloadAnimation} className="h-5 w-5" />

      <span className="text-xs">Download</span>
    </div>
  );
};

export default Download;
